"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModule = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.environment");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

var _Page = _interopRequireDefault(require("./Page"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const LoadingMessage = () => null;

const getModule = (myModules, key) => {
  const currentModule = myModules.find(module => module.id === key);
  return currentModule.loader;
};

exports.getModule = getModule;

const createRouter = function (urlLibrary, modulesLibrary, contextData) {
  let projectId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  const {
    name: enviromentKey
  } = (0, _gerenciatdUtils.findOutEnv)();
  const pageList = urlLibrary.map(item => item);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(LoadingMessage, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Switch, {
      children: pageList.map(pageData => {
        if (pageData) {
          const {
            loader,
            pathName,
            exact,
            redirection,
            onlyDev,
            pageId,
            seoCustomValue,
            isBuyProcess,
            loggedPage,
            differentLoginStatusRedirect
          } = pageData;
          let path2Use = pathName;

          if (pathName && pathName[enviromentKey]) {
            path2Use = pathName[enviromentKey];
          }

          const component = getModule(modulesLibrary, loader);
          let allowToShow = true;

          if (onlyDev) {
            allowToShow = enviromentKey === 'dev';
          }

          if (allowToShow) {
            // Redirect when login status is different to config
            let url2go = null;
            let loginStatusRedirect2Use = null;

            if (differentLoginStatusRedirect && differentLoginStatusRedirect[enviromentKey]) {
              loginStatusRedirect2Use = differentLoginStatusRedirect[enviromentKey];
            }

            if (contextData && loginStatusRedirect2Use) {
              if (loggedPage && !contextData.userType || !loggedPage && contextData.userType) {
                url2go = loginStatusRedirect2Use;

                if (document && document.location && document.location.search) {
                  const searchParams = document.location.search;

                  if (searchParams.indexOf('spaRedirect') === -1) {
                    url2go = `${url2go}${searchParams}&spaRedirect=true`;
                  } else {
                    url2go = `${url2go}${searchParams}`;
                  }
                } else if (!document.location.search) {
                  url2go = `${url2go}?spaRedirect=true`;
                }
              }
            } // END Redirect when login status is different to config


            if (component && !redirection && !url2go) {
              return path2Use.map(currentPathName => {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
                  exact: exact,
                  path: currentPathName,
                  render: props => {
                    const ComponentPage = component;
                    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
                      children: [/*#__PURE__*/(0, _react.createElement)(_Page.default, _objectSpread(_objectSpread({}, props), {}, {
                        key: `fragment-${currentPathName}-${(0, _gerenciatdUtils2.giveRandomNumber)(1, 99)}`,
                        projectId: projectId,
                        pageId: pageId,
                        seoCustomValue: seoCustomValue,
                        context: contextData,
                        isBuyProcess: isBuyProcess
                      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(ComponentPage, _objectSpread(_objectSpread({}, props), {}, {
                        projectId: projectId
                      }))]
                    }, `fragment-${currentPathName}-${(0, _gerenciatdUtils2.giveRandomNumber)(1, 99)}`);
                  }
                }, `route-${currentPathName}-${(0, _gerenciatdUtils2.giveRandomNumber)(1, 99)}`);
              });
            }

            if (redirection) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
                exact: exact,
                path: `${path2Use}`,
                render: () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Redirect, {
                  to: redirection
                })
              }, `redirect${path2Use}`);
            }

            if (url2go) {
              let mustInjectRedirection = false;
              let myCurrentLocation = document.location.pathname;

              if (myCurrentLocation && myCurrentLocation.length) {
                const lastChar = myCurrentLocation[myCurrentLocation.length - 1];

                if (lastChar !== '/') {
                  myCurrentLocation = `${myCurrentLocation}/`;
                }
              }

              path2Use.forEach(itemPath => {
                if (!mustInjectRedirection && itemPath === myCurrentLocation) {
                  mustInjectRedirection = true;
                }
              });

              if (!mustInjectRedirection) {
                return null;
              }

              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
                exact: exact,
                path: myCurrentLocation,
                render: () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Redirect, {
                  to: url2go
                })
              }, `redirect${url2go}`);
            }

            return null;
          }
        }

        return null;
      })
    })
  });
};

var _default = createRouter;
exports.default = _default;

//# sourceMappingURL=createRouter.js.map